
// Fired when the LAST host/teacher leaves the Zoom meeting (host count drops to 0).
// ZoomMtgController gates the dispatch on the live host count, so a single host
// leaving while others remain does NOT fire this — only the last one out does.
// ZoomClient reacts by ending the live class (mark not-live + broadcast course-finished).
export class MeetingEndedEvent extends CustomEvent {
    static name = 'meetingEnded'

    constructor () {
        super(MeetingEndedEvent.name, {
            bubbles: true,
            cancelable: true
        })
    }
}
